import { Component, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseScrollbarDirective } from '@fuse/directives/scrollbar';
import { MainComponent } from '@project/main.component';
import { MarkdownModule } from 'ngx-markdown';

@Component({
    selector: 'app-changelogs',
    templateUrl: './changelog.component.html',
    styleUrls: ['./changelog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        MatButtonModule,
        MatTooltipModule,
        MatIconModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        MarkdownModule,
        FuseScrollbarDirective,
    ],
})
export class ChangelogComponent extends MainComponent {
    htmlStr: string;

    constructor() {
        super();
    }
}
